module.exports = __webpack_public_path__ + "img/icon-xuanzhong@2x.82be0f2d.png";